import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react";

import { useUpdateRowData } from "../hooks";
import { IKeyStringAndValue } from "../types/Types";

type TContextProvider = {
  children: ReactNode;
  listView: string;
};
interface ICreateContext {
  listView: string;
  filteredData: Array<IKeyStringAndValue>;
  setFilteredData: Dispatch<SetStateAction<Array<IKeyStringAndValue>>>;
  filterOptions: IKeyStringAndValue | { typeOfPump?: string };
  setFilterOptions: Dispatch<
    SetStateAction<IKeyStringAndValue | { typeOfPump?: string }>
  >;
  sortedField: string | null;
  setSortedField: Dispatch<SetStateAction<string | null>>;
  arrowState: boolean | null;
  setArrowState: Dispatch<SetStateAction<boolean | null>>;
  currentPage: number | string;
  setCurrentPage: Dispatch<SetStateAction<number | string>>;
  selected: Array<IKeyStringAndValue>;
  setSelected: Dispatch<SetStateAction<Array<IKeyStringAndValue>>>;
  selectedData: IKeyStringAndValue[];
  setSelectedData: Dispatch<SetStateAction<Array<IKeyStringAndValue>>>;
  isCompare: boolean;
  setIsCompare: Dispatch<SetStateAction<boolean>>;
  inputValue: string;
  setInputValue: Dispatch<SetStateAction<string>>;
}
const Context = createContext<ICreateContext | undefined>(undefined);

export const useTableContext = () => {
  const useTableContext = useContext(Context);
  if (typeof useTableContext === "undefined")
    throw new Error("useTableContext must be used inside Context.Provider");
  return useTableContext;
};

export const ContextProvider = ({ children, listView }: TContextProvider) => {
  //Data reduced by all filters
  const [filteredData, setFilteredData] = useState(useUpdateRowData(listView));
  //Filter key and values for filtering data
  const [filterOptions, setFilterOptions] = useState(
    listView === "test_tabeller_varmepumpar" ? { typeOfPump: "fl" } : {}
  );
  //Which column to be sorted
  const [sortedField, setSortedField] = useState<string | null>(null);
  //Arrow up or down
  const [arrowState, setArrowState] = useState<boolean | null>(null);
  //Active page (pagination)
  const [currentPage, setCurrentPage] = useState<number | string>(1);
  //All selected items
  const [selected, setSelected] = useState<Array<IKeyStringAndValue>>([]);
  //Filted data with all selected items
  const [selectedData, setSelectedData] = useState<IKeyStringAndValue[]>([]);
  //Check if compare mode is on
  const [isCompare, setIsCompare] = useState(false);
  //Search field value
  const [inputValue, setInputValue] = useState("");

  return (
    <Context.Provider
      value={{
        listView,
        filteredData,
        setFilteredData,
        filterOptions,
        setFilterOptions,
        sortedField,
        setSortedField,
        arrowState,
        setArrowState,
        currentPage,
        setCurrentPage,
        selected,
        setSelected,
        selectedData,
        setSelectedData,
        isCompare,
        setIsCompare,
        inputValue,
        setInputValue,
      }}
    >
      {children}
    </Context.Provider>
  );
};
